export default __webpack_public_path__ + "static/limewood-164d0ae7f0099abd99918b998008cc97.svg";